<template>
  <my-dialog ref="editForm" title="集采入库单详情" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%">
    <div class="main_bg">
      <div class="item_info border_Warningcolor">
        <el-descriptions class="margin-top" title="基本信息" :column="3" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              入库单号
            </template>
            {{ this.editForm.inputStoreNo }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              供应商
            </template>
            <el-select v-model="this.supplyInfo.keyId" placeholder="请选择供应商" clearable style="width: 100%"
              @change="handleSelectSupply" disabled>
              <el-option v-for="item in supplyList" :label="item.name" :value="item.keyId"
                :key="item.keyId"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              供应商联系人
            </template>
            {{ this.supplyInfo.contactUser }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              供应商电话
            </template>
            {{ this.supplyInfo.contactPhone }}
          </el-descriptions-item>
          <el-descriptions-item span="2">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              供应商地址
            </template>
            {{ this.supplyInfo.address }}
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              备注
            </template>
            {{ this.editForm.remark }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info border_Green">
        <div class="item_title">
          <div class="title">商品信息</div>
          <div class="goodsInfoData">
            商品信息：{{ goodsName }}【{{ goodsType }}】
          </div>
        </div>
        <div class="tableData">
          <table class="highlight-table">
            <thead>
              <tr>
                <th class="fixed-column" style="width: 60px;">球镜\柱镜</th>
                <th v-for="(item, colIndex) in zhuJingList" :key="colIndex">
                  {{ item.paramsValue }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(itemTr, rowIndex) in qiuJingList" :key="rowIndex">
                <td class="qiuJing fixed-column">
                  {{ itemTr.paramsValue }}
                </td>
                <td v-for="(item, colIndex) in zhuJingList" :key="colIndex">
                  <span v-if="goodsStockQtyList[rowIndex][colIndex] > 0" class="inputQuantity tdContent">
                    {{ goodsStockQtyList[rowIndex][colIndex] }}
                  </span>
                  <span v-else class="inputQuantity">
                    {{ goodsStockQtyList[rowIndex][colIndex] }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button
        v-if="btnPermission.audit && (this.editForm.inputUserKeyId === '' || this.editForm.inputUserKeyId === null)"
        size="small" type="primary" class="el-icon-audit" @click="auditInputStore()">审核</el-button>
    </div>
  </my-dialog>
</template>
<script>
import { GetInputStoreDeatail, AuditInputStore } from "@/api/receiptApi.js";
import { getSupplyInfoList, GetGoodsParamsList } from "@/api/baseDataApi.js";

export default {
  props: [],
  data() {
    return {
      showDialog: false,
      saveloading: false,
      editForm: {
        keyId: "",
        inputStoreNo: "",
        inputUserKeyId: "",
        remark: "",
      },
      supplyList: [],
      supplyInfo: {
        keyId: "",
        name: "",
        contactUser: "",
        contactPhone: "",
        address: "",
      },
      goodsType: "",
      goodsName: "",
      goodsStockQtyList: [],
      qiuJingList: [],
      zhuJingList: [],
      // 按钮权限
      btnPermission: {
        audit: false,
      },
    };
  },
  computed: {},
  watch: {},
  components: {},
  created() {
    // 按钮权限
    this.getBtnPermission();
  },
  methods: {
    // 显示
    showDetailDialog(keyId) {
      this.editForm.keyId = keyId;
      this.showDialog = true;
      this.getSupplyInfoList();
      this.$nextTick(() => {
        this.GetGoodsParamsList();
        setTimeout(() => {
          this.GetInputStoreDeatail();
        }, 100)
      })
    },
    // 获取入库单详情
    GetInputStoreDeatail() {
      this.saveloading = true;
      const params = {
        keyId: this.editForm.keyId,
      };
      GetInputStoreDeatail(params)
        .then((res) => {
          this.saveloading = false;
          if (res.code == 1) {
            this.editForm.inputStoreNo = res.data.inputStoreNo;
            this.editForm.inputUserKeyId = res.data.inputUserKeyId;
            this.editForm.remark = res.data.remark;
            this.goodsType = res.data.goodsType;
            this.goodsName = res.data.goodsName;
            if (res.data.dtls != null && res.data.dtls.length > 0) {
              this.handleSelectSupply(res.data.dtls[0].supplyKeyId);
              for (let i = 0; i < this.qiuJingList.length; i++) {
                for (let j = 0; j < this.zhuJingList.length; j++) {
                  let item = res.data.dtls.find(
                    (item) =>
                      item.goodsInfo.paramsKeyId1 ==
                      this.qiuJingList[i].keyId &&
                      item.goodsInfo.paramsKeyId2 == this.zhuJingList[j].keyId
                  );
                  if (item != null) {
                    this.goodsStockQtyList[i][j] = item.quantity;
                  }
                }
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.saveloading = false;
          this.$message.error("生成失败，请稍后再试！");
        });
    },
    // 获取供应商
    getSupplyInfoList() {
      const paramer = {};
      getSupplyInfoList(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.supplyList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取供应商信息失败!");
        });
    },
    // 选择供应商
    handleSelectSupply(val) {
      this.supplyInfo = this.supplyList.find((item) => item.keyId == val);
    },
    // 关闭
    closeDialog() {
      this.$data.editForm = this.$options.data.call(this).editForm;
      this.showDialog = false;
    },
    //判断为空则用 -- 替代
    transformEmpty(obj) {
      if (obj == "" || obj == null || obj == undefined) {
        obj = "--";
      }
      return obj;
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
            this.goodsStockQtyList = [];
            for (let i = 0; i < this.qiuJingList.length; i++) {
              let rowItem = [];
              for (let j = 0; j < this.zhuJingList.length; j++) {
                rowItem.push();
              }
              this.goodsStockQtyList.push(rowItem);
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 审核
    auditInputStore() {
      this.$confirm("确定要审核入库单【" + this.editForm.inputStoreNo + "】吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let parmter = {
          keyIds: [this.editForm.keyId],
        };
        AuditInputStore(parmter)
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "已成功审核入库单【" + this.editForm.inputStoreNo + "】!",
              });
              this.showDialog = false;
              this.$parent.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("审核失败，请稍后再试！");
          });
      });
    },
    // 按钮权限
    getBtnPermission() {
      this.btnPermission.audit = this.$checkBtnPermission('/inputStore/index', 'audit');
    },
  },
};
</script>
<style scoped lang="scss">
.main_bg {
  padding: 10px;
  margin-top: -15px;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
  border-left: 5px solid #ff9900;
}

.border_Green {
  border-left: 5px solid #00cc66;
}

.item_title {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  justify-content: space-between;

  .title {
    display: inline-block;
    unicode-bidi: isolate;
  }

  .goodsInfoData {
    font-size: 18px;
    font-weight: 900;
    font-family: "楷体";
  }
}

.tableData {
  width: 100%;
  display: flex;
  margin-top: 20px;
  height: 500px;
  /* 固定容器高度 */
  overflow-y: auto;
  /* 启用垂直滚动 */

  table {
    border: 2px solid #000;
    border-radius: 5px;
    width: auto;
    min-width: 100%;
    background-color: #4ab453;
  }

  table,
  th {
    height: 25px;
    font-family: "楷体";
    font-size: 14px;
    font-weight: 600;
    min-width: 40px;
    border: 1px solid #000;
    position: sticky;
    top: 1px;
    left: 1px;
    background-color: #4ab453;
    z-index: 10;
    /* 确保表头在滚动时覆盖内容 */
    color: white;
    flex: 1;
  }

  table,
  td {
    border: 1px solid #000;
    padding: 0;
    margin: 0;
    text-align: center;
    border-collapse: collapse;
    font-size: 14px;
    font-family: "宋体";
    font-weight: 600;
    background-color: #4ab453;

    .inputQuantity {
      background-color: #4ab453;
      border: none;
      outline: none;
      box-sizing: border-box;
      text-align: center;
      align-items: center;
    }
  }

  .qiuJing {
    font-size: 14px;
    font-weight: 600;
    height: 25px;
    line-height: 25px;
    font-family: "楷体";
    width: 100px;
  }
}

/* 固定列样式 */
.fixed-column {
  position: sticky;
  left: 1px;
  z-index: 2;
  background: #4ab453 !important;
  border-right: 2px solid #dee2e6;
}

/* 固定列表头特殊处理 */
thead th.fixed-column {
  z-index: 14;
  left: 1px;
}

.highlight-table {
  border-collapse: collapse;
}

.highlight-table th,
.highlight-table td {
  border: 1px solid #ddd;
}
</style>